import type { Nullable } from "@iot-platform/core";
import { IotError } from "@iot-platform/core";
import { t } from "i18next";

export class LoginBlockedError extends IotError {
    /**
     * Unlock instant reported by the backend, or null when the response did
     * not include a parseable `blocked_until` value.
     */
    constructor(public readonly blockedUntil: Nullable<Date> = null) {
        super(t("error:authentication.login.blockedMessage"));

        Object.setPrototypeOf(this, LoginBlockedError.prototype);
    }
}
